import './timeLine.css';
import { useState } from 'react';

export default function TimeLine({onTimeChange}) {

    const buttonIndex = ['.05rem', '6.7rem', '13.65rem', '20.2rem'];

    const [activeButton, setActiveButton] = useState(buttonIndex[0]);

    const timeLineClick = (click) => {
        setActiveButton(buttonIndex[click]);
    };

    return(
        <div className="time-line">
            <div className="time-line-container">
                <div className="time-line-button-active" style={{transform: `translateX(${activeButton})`}} />
                <div className="time-line-button" onClick={() => {timeLineClick(0); onTimeChange(0)}}>
                    <strong>1w</strong> 
                </div>
                <div className="time-line-button" onClick={() => {timeLineClick(1); onTimeChange(1)}}>
                    <strong>1m</strong>
                </div>
                <div className="time-line-button" onClick={() => {timeLineClick(2); onTimeChange(2)}}>
                    <strong>6m</strong>
                </div>
                <div className="time-line-button" onClick={() => {timeLineClick(3); onTimeChange(3)}}>
                    <strong>1y</strong>
                </div>
            </div>
        </div>
    )
}